<template>
	<div class="main-content-relative" v-loading="loading">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-12">
					<div v-if="ready" class="main-content-box">
						<el-breadcrumb v-if="userRole === 1" separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/admin/companies' }">{{ translations.navigation.companies }}</el-breadcrumb-item>
							<el-breadcrumb-item>{{ company.companyName }}</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/admin/companies/' + $route.params.id + '/users' }">{{ translations.navigation.users }}</el-breadcrumb-item>
							<el-breadcrumb-item>{{ translations.labels.userAdd }}</el-breadcrumb-item>
						</el-breadcrumb>
						<el-breadcrumb v-else separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/users' }">{{ translations.navigation.users }}</el-breadcrumb-item>
							<el-breadcrumb-item>{{ translations.labels.userAdd }}</el-breadcrumb-item>
						</el-breadcrumb>
						<h1>
							{{ translations.labels.userAdd }}
						</h1>
						<el-form @submit.prevent.native="handleSubmit('form')" :model="form" :rules="rules" ref="form">
							<div class="row">
								<div class="col-lg-6">
									<el-form-item :label="translations.labels.title" prop="title" id="v-step-0">
										<el-select v-model="form.title" :placeholder="translations.labels.chooseTitle" style="width: 100%">
											<el-option v-for="(item, index) in translations.labels.titles" :key="index" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-lg-6">
									<el-form-item :label="translations.labels.title">
										<el-input suffix-icon="el-icon-user" type="text" v-model="form.titleText" :placeholder="translations.labels.enterTitle"></el-input>
									</el-form-item>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-6">
									<el-form-item :label="translations.labels.firstName" prop="firstName">
										<el-input type="text" suffix-icon="el-icon-user" v-model="form.firstName" :placeholder="translations.labels.enterFirstName"></el-input>
									</el-form-item>
								</div>
								<div class="col-lg-6">
									<el-form-item :label="translations.labels.lastName" prop="lastName">
										<el-input type="text" suffix-icon="el-icon-user" v-model="form.lastName" :placeholder="translations.labels.enterLastName"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-6 col-md-12">
									<el-form-item :label="translations.labels.email" prop="email">
										<el-input type="email" suffix-icon="el-icon-message" v-model="form.email" :placeholder="translations.labels.enterEmail" autocomplete="off"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-6">
									<el-form-item :label="translations.labels.prefferedLanguage" prop="language" id="v-step-1">
										<el-select v-model="form.language" :placeholder="translations.labels.enterPrefferedLanguage" style="width: 100%">
											<el-option v-for="(language, index) in languages" :key="index" :label="language.label" :value="language.value">
												<div class="flex-start" style="height: 34px;">
													<span>
														<img :src="'/images/flags/' + language.value + '.png'" style="width: 20px; height: 15px; margin-right: 5px; display: block;" />
													</span>
													<span>
														{{ language.label }}
													</span>
												</div>
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<div v-if="userRole === 2" class="row">
								<div class="col-lg-12">
									<el-form-item>
										<label for="email" class="el-form-item__label">{{ translations.labels.assignScreens }}</label>
										<el-select v-model="form.hasRightsOnScreens" multiple :placeholder="translations.labels.enterAssignScreens" style="width: 100%">
											<el-option v-for="screen in availableScreens" :key="screen.id" :label="screen.name" :value="screen.id"></el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<el-form-item class="margin-top-10">
								<el-button native-type="submit" type="primary" plain>{{ translations.labels.save }}</el-button>
								<el-button plain @click="handleCancel()">{{ translations.labels.cancel }}</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/admin/api'
import { mapState } from 'vuex'

export default {
	name: 'UsersAdd',
	metaInfo () {
		return {
			title: this.translations.labels.userAdd
		}
	},
	data() {
		return {
			loading: true,
			ready: false,
			languages: this.$config.languages,
			company: {},
			form: {
				companyId: null,
				firstName: '',
				lastName: '',
				email: '',
				title: '',
				titleText: '',
				hasRightsOnScreens: [],
				language: ''
			},
			rules: {
				title: [
					{ required: true, message: this.$store.state.translations.labels.selectTitle, trigger: 'blur' },
				],
				firstName: [
					{ required: true, message: this.$store.state.translations.labels.enterFirstName, trigger: 'blur' },
				],
				lastName: [
					{ required: true, message: this.$store.state.translations.labels.enterLastName, trigger: 'blur' },
				],
				email: [
					{ required: true, message: this.$store.state.translations.labels.enterEmail, trigger: 'blur' },
					{ type: 'email', message: this.$store.state.translations.labels.enterCorrectEmail, trigger: 'blur' }
				],
				language: [
					{ required: true, message: this.$store.state.translations.labels.enterLanguage, trigger: 'blur' },
				],
			},
			availableScreens: []
		}
	},
	computed: {
        ...mapState(['translations', 'user', 'userRole'])
	},
	mounted () {
		this.form.companyId = parseInt(this.user.roles[0].id) === 1 ? parseInt(this.$route.params.id) : parseInt(this.user.companyId)
		this.loadData()
	},
	methods: {
		loadData () {
			const companyId = parseInt(this.user.roles[0].id) === 1 ? this.$route.params.id : this.user.companyId
			HTTP({
				method: 'GET',
				url: '/companies/' + companyId + '/screens',
				crossdomain: true
			})
			.then(response => {
				this.availableScreens = response.data
				if (this.userRole === 1) {
					this.loadCompany(this.$route.params.id)
				} else {
					this.ready = true
					this.loading = false
				}
			})
		},
		loadCompany (id) {
			HTTP({
				method: 'GET',
				url: '/companies/' + id,
				crossdomain: true
			})
			.then(response => {
				this.company = response.data
				this.ready = true
				this.loading = false
			})
		},
		handleCancel () {
			if (this.userRole === 1) {
				this.$router.push('/admin/companies/' + this.$route.params.id + '/users')
			} else {
				this.$router.push('/users')
			}
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					HTTP({
						method: 'POST',
						url: '/users',
						crossdomain: true,
						data: this.form
					})
					.then(() => {
						if (this.userRole === 1) {
							this.$router.push('/admin/companies/' + this.$route.params.id + '/users')
						} else {
							this.$router.push('/users')
						}
						this.displayMessage(this.translations.labels.success, this.translations.messages.successCreateUser, 'success')
					})
					.catch(error => {
						const errorCode = error.response.data.status
						this.loading = false
						this.displayMessage(this.translations.labels.fail, this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
